import { Company } from 'generated/apolloComponents'
import React, { useEffect } from 'react'

interface IProps {
  company: Company
}

const TwitterContainer = ({ company }: IProps) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://platform.twitter.com/widgets.js'
    document.getElementsByClassName('twitter-embed')[0].appendChild(script)
  }, [])

  return (
    <section
      className='twitterContainer overflow-auto'
      style={{ height: '500px' }}
    >
      {company.twitter && (
        <div className='twitter-embed'>
          <a
            className='twitter-timeline'
            data-theme='light'
            data-height='700'
            data-tweet-limit='5'
            data-chrome='noheader nofooter noborders'
            href={`${company.twitter}?ref_src=twsrc%5Etfw`}
          />
        </div>
      )}
    </section>
  )
}

export default TwitterContainer
